module.exports = __webpack_public_path__ + "static/media/lv.d24278f8.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/lv.svg
// module id = 702
// module chunks = 0